import { useContext, useState } from 'react'
import { Divider, Grid, TextField, Typography } from '@mui/material';
import contactStyle from "../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import intentStyles from "../../../../../assets/styles/componentStyles/intentStyles/intentStyle.module.scss"
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import agent from '../../../../../services/api';
import GlobalButton from '../../../../../components/utility/globalButton/button';
import Required from '../../../../../components/utility/required';
import { addThreadTagPayload } from '../../../../../models/axiosModel';
import { ColorPicker } from 'material-ui-color';
import { useGenericStore } from '../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import clsx from "clsx";

const CreateUpdateThreadTagPopup = () => {
    
    const { getThreadTagApi, selectedThreadTag, setSelectedThreadTag, setFlagUpdateThreadTagPopup } = useRuleBasedInboxStore(useShallow((state) => ({
        getThreadTagApi: state.getThreadTagApi,
        selectedThreadTag: state.selectedThreadTag,
        setSelectedThreadTag: state.setSelectedThreadTag,
        setFlagUpdateThreadTagPopup: state.setFlagUpdateThreadTagPopup
    })));

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload

    const [tagPayload, setTagPayload] = useState<addThreadTagPayload>(selectedThreadTag ? selectedThreadTag : {
        ticket_tag_name: '',
        ticket_tag_color: null
    })

    const checkDisableCreateBtn = () => {
        if(tagPayload?.ticket_tag_name?.trim()?.length){
            return false;   
        }
        return true;
    }

    const onCliCkOfCancel = () => {
        setFlagUpdateThreadTagPopup(false);
        setSelectedThreadTag(null);
    }

    const onClickOfCreate = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        let res;
        if(selectedThreadTag){
            // Update Tag Call.
            const payload = {
                ticket_tag_name: tagPayload?.ticket_tag_name,
                ticket_tag_id: selectedThreadTag?.ticket_tag_id,
                ticket_tag_color: tagPayload?.ticket_tag_color
            }

            res = await agent.updateThreadTags.put(payload);
        } else {
            // Create Tag Call.
            res = await agent.addThreadtags.post(tagPayload);
        }
        
        if(!(res.status)){
            handleError(res);
        } else {
            getThreadTagApi();
            showSuccess(`Tag ${selectedThreadTag ? "Updated" : "Created"} Successfully.`)
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));

        onCliCkOfCancel();
    }

    const createUpdateTagPopupTitle = () => {
        if(selectedThreadTag){
            return `Update Tag - ${selectedThreadTag?.ticket_tag_name}`;
        } else {
            return "Create New Tag"; 
        }
    }

    const onChangeOfField = (key: keyof addThreadTagPayload, value: any) => {
        setTagPayload((prev) => {
            return {
                ...prev,
                [key]: value
            }
        })
    }

    return (
        <>
            <Grid item xs={12}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item textAlign={"center"}>
                        <Typography className={contactStyle.popupTitleTypography}>
                            {createUpdateTagPopupTitle()}
                        </Typography>
                    </Grid> 

                    <Divider className={contactStyle.popupTitleDivider} /> 

                    <Grid item>
                        <Grid container className={`${contactStyle.popupBodyGridContainer}`} gap={2}>
                            
                            <Grid item xs={12} className={globalStyles.fullwidth}>
                                <Grid container gap={1} direction={"column"}>
                                    <Grid item xs={12}>
                                        <Typography className={contactStyle.popupFieldTypography}>
                                            Tag Name <Required />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            value={tagPayload?.ticket_tag_name}
                                            onChange={(e) => { onChangeOfField('ticket_tag_name', e.target.value) }}
                                            className={clsx(contactStyle.campaignContactPopupTextField, globalStyles.fullwidth)}
                                            placeholder='Enter a Tag...'
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} className={globalStyles.fullwidth}>
                                <Grid container gap={1} direction={"column"}>
                                    <Grid item xs={12}>
                                        <Typography className={contactStyle.popupFieldTypography}>
                                            Tag Color
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} className={intentStyles.intentColorPicker}>
                                        <ColorPicker
                                            // name='color'
                                            value={typeof tagPayload?.ticket_tag_color === 'string' ? tagPayload?.ticket_tag_color : ''}
                                            onChange={(event: any) => {
                                                let colorValue = "";
                                                if (event.error) {
                                                    colorValue = event.raw;
                                                }
                                                else if (event.css && event.css.backgroundColor) { 
                                                    colorValue = event.css.backgroundColor;
                                                } else if (event.target && event.target.value) {
                                                    colorValue = event.target.value;
                                                } else {
                                                    colorValue = event;
                                                }

                                                onChangeOfField('ticket_tag_color', colorValue);
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} mt={1} mb={1}>
                                <Grid container gap={2} justifyContent={"center"}>
                                    <GlobalButton
                                        className='borderedButtonStyle'
                                        buttonText="Cancel"
                                        sx={{ width: "120px" }}
                                        onClick={() => onCliCkOfCancel()}
                                    />
                                    <GlobalButton
                                        className='primaryButtonStyle'
                                        buttonText={selectedThreadTag ? "Update" : "Create"}
                                        sx={{ width: "120px" }}
                                        disabled={checkDisableCreateBtn()}
                                        onClick={() => onClickOfCreate()}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid> 
            </Grid> 
        </>
    )
}

export default CreateUpdateThreadTagPopup
